import fileSaver from 'file-saver'
import { ShiftOptions } from 'models/ICattlesData'
import { MilkingProcessDeviationType } from 'models/MilkingProcess'
import { useEffect, useState } from 'react'
import MilkingProcessService from 'services/milkingProcessService'
import { useAppDispatch } from 'store/hooks'
import { notifyUser } from 'store/notificationsSlice'

interface IExportDeviationReportProps {
	startDate: number
	endDate: number
	shiftPeriod: ShiftOptions[] | 'all'
	parlorId: number[] | 'all'
	milkerId: number[] | 'all'
	deviationType: MilkingProcessDeviationType[] | 'all'
	ordering: string[] | null
}

const useExportDeviationReport = ({
	startDate,
	endDate,
	shiftPeriod,
	parlorId,
	milkerId,
	deviationType,
	ordering,
}: IExportDeviationReportProps) => {
	const dispatch = useAppDispatch()
	const [isFetchReport, setIsFetchReport] = useState(false)

	useEffect(() => {
		if (!isFetchReport) return

		MilkingProcessService.exportMilkingProcessDeviations(
			startDate,
			endDate,
			shiftPeriod,
			parlorId,
			milkerId,
			deviationType,
			ordering,
		)
			.then(response => {
				const blob = new Blob([response.data], {
					type: response.headers['content-type'],
				})
				fileSaver.saveAs(blob, 'deviations-report.xlsx')
			})
			.catch(error => {
				dispatch(
					notifyUser({
						title: 'Генерация отчёта завершилась с ошибкой',
						description: error.message,
						isError: true,
					}),
				)
			})
			.finally(() => {
				setIsFetchReport(false)
			})
	}, [
		isFetchReport,
		startDate,
		endDate,
		shiftPeriod,
		parlorId,
		milkerId,
		deviationType,
		ordering,
		dispatch,
	])

	return { isFetchReport, setIsFetchReport }
}

export default useExportDeviationReport
